module.exports = __webpack_public_path__ + "img/bamboohr.661af2a5.svg";